<template>
  <div class="com-box" :style="{height: isEdit ? null : pagesHeight + 'px'}">
    <div class="front" :class="{'active-front': isEdit}" ref="element">
      <div class="head" v-if="!isApplayTemp">
        <div class="head-left">
          <div class="item" v-if="cmpIndex != 0" @click="moveUp">上移</div>
          <div class="item" v-if="comListLength != cmpIndex" @click="shiftDown">下移</div>
          <div class="item" v-if="comListLength > 0" @click="delCmp">删除</div>
        </div>
        <div class="head-right" @click="edit">编辑</div>
      </div>
      <preview-attention :comData="value" :tmpType="tmpType"/>
    </div>
    <div class="back" :class="{'active-back': isEdit}">
      <attention v-model="formData"/>
      <div style="height: 60px;"></div>
      <div class="footer">
        <div class="footer-item call" @click="cancel">取消</div>
        <div class="footer-item" @click="save">保存</div>
      </div>
    </div>
  </div>
</template>

<script>
import previewAttention from '@/pages/activity-home/components/attention'
import attention from '../../components/attention'
import _ from 'loadsh'
export default {
  components: {
    previewAttention,
    attention,
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: Object,
    cmpIndex: Number,
    comListLength: Number,
    isApplayTemp: Boolean,
    tmpType: Number
  },
  data() {
    return {
      isEdit: false,
      formData: {},
      pagesHeight: 178
    }
  },
  mounted() {
    // 获取组件高度
   this.$nextTick(()=> {
    let height = this.$refs.element.offsetHeight;
    this.pagesHeight = height  == '0' ? '178' : height
   })
  },
  methods: {
    edit() {
      this.formData = _.cloneDeep(this.value)
      this.isEdit = !this.isEdit
      this.$emit('handle',['attention',false])
      
    },
    cancel() {
      this.isEdit = false
      this.$emit('handle', ['attention',true])
    },
    save() {
      this.$emit('change', this.formData)
      this.$nextTick(()=> {
        this.pagesHeight = this.$refs.element.offsetHeight
        this.isEdit = false
        this.$emit('handle', ['attention',true])
      })
      // this.isEdit = false
      // this.$emit('handle',['attention',true])
    },
    delCmp() {
      this.$emit('delCmp',this.cmpIndex)
    },
    moveUp() {
      this.$emit('moveUp',this.cmpIndex)
    },
    shiftDown() {
      this.$emit('shiftDown',this.cmpIndex)
    }
  }

}
</script>

<style lang="stylus" scoped>
.com-box {
  position: relative;
  padding: 10px 0;
  box-sizing: border-box;
  perspective: 800px;
  overflow hidden;
  .front {
    position: absolute;
    left: 0;
    right: 0;
    transition: 1s;
    backface-visibility: hidden;
    .head {
      position: absolute;
      top: 10px;
      left: 10px;
      width: 95%;
      display: flex;
      justify-content: space-between;
      z-index: 9;
      .head-left {
        display: flex;
        .item {
          padding: 4px;
          border-radius: 3px;
          background: #fff;
          margin-right: 10px;
        }
      }
      .head-right {
        padding: 4px;
        border-radius: 3px;
        background: #fff;
      }
    }
  }
  .back {
    transform: rotateY(-180deg);
    backface-visibility: hidden;
    transition: 1s;
    background: #f4f4f4;
    margin-top: -10px;
    .footer {
      display: flex;
      justify-content center;
      width: 100%;
      padding: 10px 0;
    }
    .footer-item {
      color: #FFFFFF;
      padding: 10px 26px;
      border-radius: 4px;
      background: #FF6B31;
      margin-left: 20px;
    }
    .call {
      color: #FF6B31;
      background: #fff;
    }
  }
  .active-front {
    transform: rotateY(180deg);
  }
  .active-back {
    transform: rotateY(0deg);
  }
}
  
</style>